import { render, staticRenderFns } from "./SubsidyCouponList.vue?vue&type=template&id=45cfff8f&scoped=true&"
import script from "./SubsidyCouponList.vue?vue&type=script&lang=js&"
export * from "./SubsidyCouponList.vue?vue&type=script&lang=js&"
import style0 from "./SubsidyCouponList.vue?vue&type=style&index=0&id=45cfff8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfff8f",
  null
  
)

export default component.exports